import * as React from "react";

import { Smartphone } from "./output-pad-style";
import { SmartphoneInner } from "sharedUI/ui/views/smartphone/smartphone";

interface Props {
    isAIPlayer?: boolean;
    AIAccentColor?: string;
    width?: number;
    height?: number;
    scale?: number;
}

export default class OutputPad extends React.Component<Props> {
    public render() {
        const content = this.props.children;
        return (
            <Smartphone
                width={this.props.width}
                height={this.props.height}
                scale={this.props.scale}
                isAIPlayer={this.props.isAIPlayer}
                AIAccentColor={this.props.AIAccentColor}
                round={40}>
                <SmartphoneInner round={40}>{content}</SmartphoneInner>
            </Smartphone>
        );
    }
}
